import crud_actions from './crud_actions'

export const loadInstanceInfo = crud_actions.read('instanceInfo')
